import { useState } from 'react';

import { useCurrentEventQuery } from '../../../../../event/hooks/useCurrentEventQuery';
import { useCreateBedroomTransactionMutation } from '../../../../../transactions/hooks/useCreateBedroomTransactionMutation';

export const useBedroomOnlinePaymentCard = (eventId: string) => {
  const [isForceDialogVisible, setIsForceDialogVisible] =
    useState<boolean>(false);

  const { createBedroomTransaction } = useCreateBedroomTransactionMutation();
  const { data: currentEventData } = useCurrentEventQuery();
  const currentEvent = currentEventData?.currentEvent;

  const onPayWithHelloAsso = async () => {
    if (currentEvent?.areBedroomFull) {
      return;
    }

    try {
      await createBedroomTransaction({
        eventId,
      });
    } catch (error) {
      if ((error as Error).message === 'USER_ALREADY_PAYING') {
        setIsForceDialogVisible(true);
      }
    }
  };

  const onCloseForcePaymentDialog = () => {
    setIsForceDialogVisible(false);
  };
  const onForcePayment = () => {
    if (currentEvent?.areBedroomFull) {
      return;
    }

    setIsForceDialogVisible(false);
    createBedroomTransaction({
      eventId,
      force: true,
    });
  };

  return {
    onPayWithHelloAsso,
    isForceDialogVisible,
    onCloseForcePaymentDialog,
    onForcePayment,
    currentEvent,
  };
};
